import styled from 'styled-components';
import StyleGuide from 'src/style-guide';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

export const screenshotModeTopPadding = 160;
export const screenshotModeSidePadding = 100;

export const ScreenshotButton = styled('div')`
  position: absolute;
  display: flex;
  flex-direction: row;
  width: 130px;
  height: 44px;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, -24px);
  padding: 10px 25px;
  line-height: 24px;
  background-color: #247ddc;
  color: #f9faff;
  border-radius: 4px;
  z-index: 11;
  cursor: pointer;
`;

export const ScreenshotModeContainer = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: ${screenshotModeTopPadding}px ${screenshotModeSidePadding}px 0;
`;

export const AspectRatioAndGalleryContainer = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;

  @media ${DEVICE.DESKTOP_PORTRAIT} {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const CloseButtonContainer = styled(StyleGuide.Icon)<{
  size: number;
}>`
  cursor: pointer;
  position: absolute;
  top: 32px;
  left: 32px;
  transform: rotate(180deg);
  svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
    path {
      fill: #767676;
    }
  }
`;

export const ScreenshotModeTitle = styled('h3')`
  position: absolute;
  top: -61px;
  left: 0;
  flex-shrink: 0;
  height: 60px;
  font-family: Avenir Next;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  color: #0d1a4c;
`;
